import styled from 'styled-components';

import { size } from '../../layout/helpers';
import { ButtonReset } from '../../layout/reset';

export const UtilityButton = styled(ButtonReset)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${size(4)};
  height: ${size(4)};
  border-radius: ${size(1)};
  background-color: var(--c-accent-bg);
  color: var(--c-accent-fg);
  font-size: ${size(3)};
  transform-origin: 50% 50%;
  transition:
    transform 200ms ease,
    background-color 150ms ease;
  user-select: none;
  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    inset: 1px;
    background: rgba(var(--c-overlay-rgb), 1);
    border-radius: inherit;
    mix-blend-mode: soft-light;
    pointer-events: none;
    opacity: 0;
    transition: opacity 200ms ease;
  }

  &:enabled {
    &:active {
      transform: scale(0.97);
    }

    &:hover {
      &::before {
        opacity: 1;
      }
    }
  }

  &[disabled] {
    opacity: 0.37;
    cursor: not-allowed;
  }
`;
